import type { PropsWithChildren } from "react";

import { styled } from "@linaria/react";

const RotateWithTransitionWrapper = styled.div<{
  $isRotated: boolean;
  $deg: number;
  $speed?: number;
}>`
  display: inline-flex;
  transition: rotate ${({ $speed }) => $speed ?? 0.075}s ease-in-out;
  rotate: ${({ $isRotated, $deg }) => {
    if ($isRotated) {
      return `${$deg}deg`;
    }

    return "0deg";
  }};
`;

export interface RotateWithTransitionProps {
  isRotated: boolean;
  deg?: number;
  speed?: number;
}

const RotateWithTransition = ({
  children,
  isRotated,
  deg = 180,
  speed,
}: PropsWithChildren<RotateWithTransitionProps>) => {
  return (
    <RotateWithTransitionWrapper $isRotated={isRotated} $deg={deg} $speed={speed}>
      {children}
    </RotateWithTransitionWrapper>
  );
};

export default RotateWithTransition;
